<template>
  <div>
    <SingleJob />
  </div>
</template>

<script>
const notFoundMessage = "Oops! The job you're looking for doesn't seem to exist. Maybe it's been filled or removed.";
import SingleJob from "~/components/jobs/SingleJob";
import { Route } from "vue-router";
import { mapState, mapGetters } from "vuex";

export default {
  data: function () {
    return {
      title: this.$route.params.ad,
      id: this.$route.params.id
    };
  },
  components: { SingleJob },
  validate({ params }) {
    // Must be a number
    return /^\d+$/.test(params.id);
  },
  methods: {
    show: function () { }
  },

  computed: {
    ...mapState("jobs", {
      metaTags: state => state.metaTags
    }),

  },

  async asyncData({ app, params, store, error }) {
    if (process.server) {
      var id = params.id;
      var query = app.context.route.query;
      var archive = query.archive;
      if (!archive) archive = 0;

      var jobParams = { archive: archive, id: id };
      await store.dispatch("jobs/getSingleJob", {
        jobParams,
      });
      if (!store.state.jobs.isSingeJobLoaded) {
        // Call Nuxt's error function to show 404 page
        return error({ statusCode: 404, message: notFoundMessage });
      }
    }
  },
  async mounted() {
    if (process.client && !this.$store.state.jobs.isSingeJobLoaded) {


      // Client-side logic
      var jobParams = { archive: this.$route.query.archive || 0, id: this.$route.params.id };
      await this.$store.dispatch("jobs/getSingleJob", { jobParams });

    }
  },
  beforeDestroy() {
    // Reset the flag when leaving the page
    this.$store.commit('jobs/destroyJobsListings');
  },


  head() {
    return {
      title: this.metaTags.title,
      link: [{ rel: "canonical", href: this.metaTags.canonical }],
      meta: this.createMetaTags(this.metaTags)
    };
  }
};
</script>
